import { render, staticRenderFns } from "./set-up-action.vue?vue&type=template&id=b3779f08"
import script from "./set-up-action.vue?vue&type=script&lang=js"
export * from "./set-up-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports